<template>
  <div>
    <v-app id="app">
      <Snackbar />
      <router-view />
    </v-app>
  </div>
</template>
<script>
import Snackbar from "@/components/Snackbar.vue";

export default {
  name: "App",
  components: {
    Snackbar
  }
};
</script>
